<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <div class="back" @click="function() {$router.push({name:'basket'})}">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M11.666 5.83331L8.33268 9.99998L11.666 14.1666" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span>Оформление заказа</span>
        </h1>
      </div>



      <div class="page_content order">

        <div class="order_blocks">
          <recipient-block :recipient-data="recipientData"
            @recipient_fio_change="recipientData.fio = $event"
            @recipient_phone_change="recipientData.phone = $event"
          >
          </recipient-block>

          <delivery-block
              :delivery-data="deliveryData"
              @delivery_change="deliveryData.current = $event"
              @delivery_address_change="deliveryData.delivery.address = $event"
              @delivery_date_change="deliveryData.delivery.date = $event"
              @delivery_store_change="deliveryData.delivery.store_id = $event"
          >
          </delivery-block>

          <payment-block :payment-data="paymentData" @payment_change="paymentData.current = $event"></payment-block>

          <comment-block :comment-data="commentData" @comment_change="commentData = $event"></comment-block>

          <products-block :basket-data="basketData"></products-block>
        </div>

        <div class="total">
          <div class="total-panel">

            <div class="total-row">
              <span class="desc">Итого</span>
              <span class="val">{{total.price}}</span>
            </div>

            <div class="sep"></div>

            <div class="rows">
              <div class="row">
                <span class="desc">Количество товаров</span><span class="val">{{total.quantity}} шт</span>
              </div>
              <div class="row">
                <span class="desc">Без учета скидки</span><span class="val">{{total.without_discount_price}}</span>
              </div>
              <div class="row">
                <span class="desc">Стоимость доставки</span><span class="val">+{{total.delivery_price}}</span>
              </div>
              <div class="row">
                <span class="desc">Ваша скидка</span><span class="val bl">-{{total.discount_price}}</span>
              </div>
              <div class="row">
                <span class="desc">Бонусы</span><span class="val bl">{{total.bonuses}}</span>
              </div>
            </div>

            <standart-button
                @click="saveOrder()"
                style_type="prime" text="Оформить заказ">
            </standart-button>

          </div>

          <div class="checkboxes">
            <standart-checkbox
                id="privacy_policy"
                :checked="total.conf_privacy_policy"
                @change="total.conf_privacy_policy = $event"
                :error-text="total.conf_privacy_policy_error"
            >
              <template v-slot:text_content>
                Я согласен на обработку <span class="bl" @click="$router.push({name: 'privacy_policy'});">персональных данных</span>
              </template>
            </standart-checkbox>
            <standart-checkbox
                id="public_offer"
                :checked="total.conf_public_offer"
                @change="total.conf_public_offer = $event"
                :error-text="total.conf_public_offer_error"
            >
              <template v-slot:text_content>
                Я принимаю <span class="bl" @click="$router.push({name: 'offer'});">условия публичной оферты</span>
              </template>
            </standart-checkbox>
          </div>
        </div>

      </div>


    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';
import RecipientBlock from "@/components/order/RecipientBlock";
import DeliveryBlock from "@/components/order/DeliveryBlock";
import PaymentBlock from "@/components/order/PaymentBlock";
import ProductsBlock from "@/components/order/ProductsBlock";
import CommentBlock from "@/components/order/CommentBlock";
import StandartButton from "@/components/share/StandartButton";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import axios from "axios";



export default {
  name: 'OrderView',
  components: {
    StandartCheckbox,
    StandartButton,
    CommentBlock,
    ProductsBlock,
    PaymentBlock,
    DeliveryBlock,
    RecipientBlock,
    MainTemplate
  },
  data() {
    return{
      total : {
        conf_privacy_policy : false,
        conf_public_offer : false,
        conf_privacy_policy_error : "",
        conf_public_offer_error : "",
        price: 0,
        quantity: 0,
        without_discount_price: 0,
        delivery_price: 0,
        discount_price: 0,
        bonuses: 0
      },

      counterpartyData: {},
      recipientData: {fio:"", phone:"", fio_error:"", phone_error:""},
      deliveryData: {
        list:[], current:{},
        delivery : {
          address : "",
          addresses : {list:[], current:""},
          date : "",
          address_error : "",
          date_error : "",
          store_id: 0
        },
        stores: []
      },
      paymentData: {list:[], current:{}},
      commentData: "",
      basketData: []
    }
  },

  mounted() {
    this.loadData();
  },
  methods : {
    saveOrder: async function() {
      if(!this.validateOder()) {
        console.log("validate error");
        return;
      }

      const bodyFormData = new FormData;

      bodyFormData.append("PROPERTIES[RECIPIENT_NAME]", this.recipientData.fio);
      bodyFormData.append("PROPERTIES[RECIPIENT_PHONE]", this.recipientData.phone);

      bodyFormData.append("DELIVERY_ID", this.deliveryData.current.value);
      bodyFormData.append("PROPERTIES[DELIVERY_ADDRESS]", this.deliveryData.delivery.address);
      bodyFormData.append("PROPERTIES[DELIVERY_DATE]", this.deliveryData.delivery.date);
      bodyFormData.append("PROPERTIES[STORE_ID]", this.deliveryData.delivery.store_id);
      bodyFormData.append("PROPERTIES[BONUSES]", this.total.bonuses);

      bodyFormData.append("PAYMENT_ID", this.paymentData.current.value);

      bodyFormData.append("USER_DESCRIPTION", this.commentData);

      try {

        let res = await axios.post(window.api_url + 'order/save?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei', bodyFormData);

        if (res.data.status === "fail") {
          //this.account_error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          //this.$router.push({name:'order_finish'});
          this.$router.push(
              {
                name:'order_detail',
                params: {order_id: res.data.data.order_id}
              }
          )
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    validateOder : function() {
      let validation = true;

      this.recipientData.fio_error = "";
      this.recipientData.phone_error = "";
      this.total.conf_privacy_policy_error = "";
      this.total.conf_public_offer_error = "";
      this.deliveryData.delivery.address_error = "";
      this.deliveryData.delivery.date_error = "";

      if(this.recipientData.fio == "") {
        this.recipientData.fio_error = "Обязательное поле";
        validation = false;
      }

      if(this.recipientData.phone == "") {
        this.recipientData.phone_error = "Обязательное поле";
        validation = false;
      }

      if(this.recipientData.phone?.replaceAll(/\D*/gm, '').length <= 10 && this.recipientData.phone != "") {
        this.recipientData.phone_error = "Телефон введен некорректно";
        validation = false;
      }

      if(this.total.conf_privacy_policy == false) {
        this.total.conf_privacy_policy_error = "Обязательное поле";
        validation = false;
      }

      if(this.total.conf_public_offer == false) {
        this.total.conf_public_offer_error = "Обязательное поле";
        validation = false;
      }

      if(this.deliveryData.current.id == 'd_20') {
        if(this.deliveryData.delivery.address == "") {
          this.deliveryData.delivery.address_error = "Обязательное поле";
          validation = false;
        }
        if(this.deliveryData.delivery.date == "") {
          this.deliveryData.delivery.date_error = "Обязательное поле";
          validation = false;
        }
      }

      return validation;
    },
    loadData : async function() {
      let res = await axios.get(window.api_url + "basket/get?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      this.total.price = res.data.data.total_all_price;
      this.total.quantity = res.data.data.total_quantity;
      this.total.without_discount_price = res.data.data.total_wd_all_price;
      this.total.delivery_price = res.data.data.total_delivery_price;
      this.total.discount_price = res.data.data.total_discount_price;

      this.total.bonuses = res.data.data.total_all_bonuses;

      this.basketData = res.data.data.list;



      let res2 = await axios.get(window.api_url + "order/setup?api=y&ext=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");




      this.counterpartyData = res2.data.data.current_counterparty;


      let recipient_id = this.$route.query.recipient;
      for(let recipient of res2.data.data.recipients) {
        if(recipient.id == recipient_id) {
          this.recipientData = recipient;
          break;
        }
      }

      let payment_id = this.$route.query.payment;
      if(payment_id == null || payment_id == 0) {
        payment_id = "p_18";
      }
      this.paymentData.list = res2.data.data.payment_methods;
      for(let payment of res2.data.data.payment_methods) {
        if(payment.id == payment_id) {
          this.paymentData.current = payment;
          break;
        }
      }

      this.deliveryData.list = res2.data.data.delivery_methods;
      this.deliveryData.current = res2.data.data.delivery_methods[0];
      this.deliveryData.stores = res2.data.data.available_pickups;
      this.deliveryData.delivery.store_id = res2.data.data.available_pickups[0].id;
      this.deliveryData.delivery.addresses = res2.data.data.current_counterparty.addresses;
    }
  }
}
</script>

<style scoped>

.back {
  height: 40px;
  width: 40px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--White);
  cursor: pointer;
  border: 1px solid var(--Border, #EDEDED);
}

.page_top .title {
  gap: 12px;
  align-items: center;
}

.page_content.order {
  display: flex;
  gap: 20px;
}

.order_blocks {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.total {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.total-panel {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-row .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.total-row .val {
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.total .sep {
  background: var(--Border);
  height: 1px;
  width: 100%;
  margin: 20px 0px;
}

.total .rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.total .rows .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total .rows .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.total .rows .val {
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.total .rows .val.bl {
  color: var(--Blue, #1B78BC);
}

.total-panel .standart_button {
  margin-top: 30px;
  width: 100%;
}

.total .checkboxes {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .page_content.order {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .order_blocks {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
</style>



<style>

.order_block {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
  box-sizing: border-box;
}

.order_block .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  text-align: start;
}

.total .checkboxes .standart-checkbox .custom-checkbox{
  background: var(--White);
}

.total .checkboxes .standart-checkbox .custom-checkbox.checked{
  background: var(--Blue, #1B78BC);
}

.total .checkboxes .standart-checkbox .text_content{
  color: var(--Black, #222);
}

.total .checkboxes .standart-checkbox span.bl{
  color: var(--Blue, #1B78BC);
  text-decoration: underline;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .order_block {
    padding: 18px;
  }
}

</style>
